var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M38.97657,.02355L.6246,7.77056c-.44144,.10667-.71002,.54345-.59991,.97557,.04774,.18735,.16257,.35188,.32361,.46369l8.39412,7.21356c.49663,.42596,1.21202,.50264,1.78935,.19179L32.65082,4.66548c.14579-.07705,.48473-.21306,.57673-.07732s-.15177,.3859-.28467,.48924L12.914,19.60847c-.5583,.40323-.77617,1.11952-.53452,1.75736l4.14081,11.03074c.11703,.43195,.5696,.69016,1.01084,.57672,.17966-.04619,.33802-.1503,.4495-.29554L39.83833,1.28692c.27065-.35712,.19359-.86198-.17211-1.12763-.19786-.14373-.45084-.19352-.68965-.13574Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b2fdd236d84f49d29c7e0ef0b598ff35.svg";
export { ForwardRef as ReactComponent };